import { render, staticRenderFns } from "./ItemizeMoney.vue?vue&type=template&id=71028367"
import script from "./ItemizeMoney.vue?vue&type=script&lang=js"
export * from "./ItemizeMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports